import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const PublicRoute = ({ children }) => {
	const { isAuthenticated } = useAuth();

	// Ha be van jelentkezve és olyan oldalon van, ami nem igényel authentikációt,
	// akkor átirányítjuk a HomePage-re (ez a bejelentkezett főoldal)
	if (isAuthenticated) {
		return <Navigate to="/Home" />;
	}

	return children;
};

export default PublicRoute;
